import { GeoPoint } from "./geoPoint";

export class GeoMeshData {
    constructor(public points: GeoPoint[], public indices: number[]) {
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/geoMeshData.ts